import React from 'react';
import ReactDOM from 'react-dom';

// @ts-ignore
import ReactReadMoreReadLess from "react-read-more-read-less";

type ReadMoreProps = {
    data: string;
    charLimit: number;
}

const ReadMore: React.FC<ReadMoreProps> = (props) => {
    return (
        <ReactReadMoreReadLess
            charLimit={props.charLimit}
            readMoreText={"Read more ▼"}
            readLessText={"Read less ▲"}
        >
            {props.data}
        </ReactReadMoreReadLess>
    );
}

export default ReadMore;

if (document.getElementsByClassName('read-more')) {
    const element = document.getElementsByClassName('read-more')!
    document.querySelectorAll('.read-more').forEach((singleElement) => {
        const data = singleElement.getAttribute('data-read-more');
        const limit = singleElement.getAttribute('data-char-limit');
        const charLimit = limit ? parseInt(limit) : 50;
        if( data ) {
            ReactDOM.render(<ReadMore data={data} charLimit={charLimit}/>, singleElement);
        }
    });
}
